import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
    import {
        SIGNIN,
        SIGNUP,
        HOME,
        USERS,
        USERLIST,
        USERNEW,
        ACTIVITYTIMES,
        USEREDIT,
        ACTIVITYTILIST,
        EXPIRATIONTOKEN,
        CASEMANAGERBULKLOAD,
        CASEMANAGERLIST,
        CASEMANAGEMENTLIST,
        WECALLYOU,
        CHAT,
        VIDEOCALL,
        WECALLYOUADMIN,
        CASEREPORT,
        VIDEOATENTION,
        ACTIVITYTIMESEXPORT,
        CASES,
        BLOCKPAGES,
        PAGENOTFOUND,
        SURVEYS,
        SURVEYLIST,
        SURVEYNEW,
        SURVEYEDIT,
        SURVEYQUESTIONS,
        CASECLOSURE,
        COMMERCIAL_CRM,
        COMMERCIAL_CRM_LOAD_BASE_BP,
        COMMERCIAL_CRM_LOAD_BASE_GUPSHUP,
        COMMERCIAL_CRM_LOAD_BASE_GUPSHUP_CUSTOM,
        CASECREATION,
        CASEOTRS,
        TEMPLATES_WSP,
        TEMPLATES_WSP_NEW,
        TEMPLATES_WSP_EDIT,
        VOICE_BLASTER,
        IVR,
        IVR_TYPIFICATION_BASE,
    } from './paths';
import PrivateRoute from './privateRoute';
import PublicRoute from './publicRoute';
import SignIn from '../components/pages/auth/signIn';
import Home from '../components/pages/home/home';
import UserNew from '../components/pages/users/new';
import SignUp from '../components/pages/auth/signUp';
import UserList from '../components/pages/users/list';
import EditUser from '../components/pages/users/edit';
import ListActivityTimes from '../components/pages/activityTimes/list';
import ExpirationToken from '../components/components/views/expirationToken';
import BulkLoad from '../components/pages/caseManager/bulkLoad';
import ListCaseManager from '../components/pages/caseManager/list';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import ExportActivityTimes from '../components/pages/exportActivityTimes/exportActivityTimes';
import ListCaseManagemenet from '../components/pages/caseManagement/list';
import WeCallYouClient from '../components/pages/weCallYou/client/weCallYouClient';
import Chat from '../components/pages/chat/chat';
import VideoCall from '../components/pages/videoCall/videoCall';
import WeCallYouAdmin from '../components/pages/weCallYou/admin/weCallYouAdmin';
import CaseReport from '../components/pages/caseReport/form';
import VideoAtention from '../components/pages/videoAtention/videoAtention';
import ListBlockPages from '../components/pages/blockpages/list';
import { MasterMessage } from '../masters/masterMessages';
import PageNotFound from '../components/components/views/pageNotFound';
import SurveyList from '../components/pages/surveys/list';
import SurveyNew from '../components/pages/surveys/new';
import SurveyEdit from '../components/pages/surveys/edit';
import SurveysFormView from '../components/pages/surveys/surveys';
import ListCaseClosure from '../components/pages/caseClosure/list';
import { validatePermission } from '../services/auth.service';
import { useAuthContext } from '../contexts/authContext';
import LoadBaseBrightpattern from '../components/pages/commercialCrm/brightpattern/baseLoad';
import LoadBaseGupshup from '../components/pages/commercialCrm/gupshup/baseLoad';
import LoadBaseGupshupCustom from '../components/pages/commercialCrm/gupshupCustom/baseLoadCustom';
import ListCaseCreation from '../components/pages/caseCreation/list';
import { CaseOTRS } from '../components/pages/caseOTRS/form';
import UsersLoad from '../components/pages/usersCreation/usersLoad';
import WspEdit from '../components/pages/templatesWhatsapp/edit';
import WspNew from '../components/pages/templatesWhatsapp/new';
import WspList from '../components/pages/templatesWhatsapp/wspList';
import VoiceBlasterForm from '../components/pages/voiceBlaster/form';
import IvrForm from '../components/pages/ivr/form';
import ListIvrTypificationBase from '../components/pages/ivrTypificationBase/list';

const AppRoutes = () => {
    const { channel } = useAuthContext();
    const { logUser, channelList } = useSelector(
        (state: RootState) => state.general
    );
    const { type } = logUser || {};
    const {
        activityTimes,
        exportActivityTimes,
        caseManagement,
        bulkLoad,
        caseManager,
        caseReport,
        caseClosure,
        caseCreation,
        caseOTRS,
        weCallYouAdmin,
        surveys,
        users,
        chat,
        wspTemplates,
        videoCall,
        weCallYou,
        videoAtencion,
        commercialCrm,
        usersCreation,
        voiceBlaster,
        ivr,
        ivrTypificationBase,
    } = MasterMessage.modules;

    return (
        <Router>
            <Routes>
                <Route path={HOME} element={<PrivateRoute />}>
                    <Route index element={<Home />} />
                </Route>
                <Route
                    path={CASES}
                    element={<PrivateRoute blockPageName={caseManagement} />}
                >
                    <Route
                        path={CASEMANAGEMENTLIST}
                        element={<ListCaseManagemenet />}
                    />
                </Route>
                {(type === 'admin' || type === 'manager') && (
                    <>
                        <Route
                            path={TEMPLATES_WSP}
                            element={
                                <PrivateRoute blockPageName={wspTemplates} />
                            }
                        >
                            <Route path={TEMPLATES_WSP} element={<WspList />} />
                            <Route
                                path={TEMPLATES_WSP_NEW}
                                element={<WspNew />}
                            />
                            <Route
                                path={`${TEMPLATES_WSP_EDIT}/:idTemplate`}
                                element={<WspEdit />}
                            />
                        </Route>
                        <Route
                            path={CASES}
                            element={<PrivateRoute blockPageName={bulkLoad} />}
                        >
                            <Route
                                path={CASEMANAGERBULKLOAD}
                                element={<BulkLoad />}
                            />
                        </Route>
                        <Route
                            path={CASES}
                            element={
                                <PrivateRoute blockPageName={caseManager} />
                            }
                        >
                            <Route
                                path={CASEMANAGERLIST}
                                element={<ListCaseManager />}
                            />
                        </Route>
                        <Route
                            path={CASES}
                            element={
                                <PrivateRoute blockPageName={caseClosure} />
                            }
                        >
                            <Route
                                path={CASECLOSURE}
                                element={<ListCaseClosure />}
                            />
                        </Route>
                        <Route
                            path={CASES}
                            element={
                                <PrivateRoute blockPageName={caseCreation} />
                            }
                        >
                            <Route
                                path={CASECREATION}
                                element={<ListCaseCreation />}
                            />
                        </Route>
                        <Route
                            path={CASES}
                            element={<PrivateRoute blockPageName={caseOTRS} />}
                        >
                            <Route path={CASEOTRS} element={<CaseOTRS />} />
                        </Route>
                        <Route
                            path={CASES}
                            element={
                                <PrivateRoute
                                    blockPageName={ivrTypificationBase}
                                />
                            }
                        >
                            <Route
                                path={IVR_TYPIFICATION_BASE}
                                element={<ListIvrTypificationBase />}
                            />
                        </Route>

                        <Route
                            path={CASES}
                            element={<PrivateRoute blockPageName={usersCreation} />}
                        >
                            <Route path="usercreation" element={<UsersLoad />} />
                        </Route>
                    </>
                )}
                <Route
                    path={ACTIVITYTIMES}
                    element={<PrivateRoute blockPageName={activityTimes} />}
                >
                    <Route
                        path={ACTIVITYTILIST}
                        element={<ListActivityTimes />}
                    />
                </Route>
                <Route
                    path={WECALLYOUADMIN}
                    element={<PrivateRoute blockPageName={weCallYouAdmin} />}
                >
                    <Route index element={<WeCallYouAdmin />} />
                </Route>
                <Route
                    path={CASES}
                    element={<PrivateRoute blockPageName={caseReport} />}
                >
                    <Route path={CASEREPORT} element={<CaseReport />} />
                </Route>
                {(type === 'admin' || type === 'commercial crm') && (
                    <>
                        <Route
                            path={COMMERCIAL_CRM}
                            element={
                                <PrivateRoute blockPageName={commercialCrm} />
                            }
                        >
                            <Route
                                path={COMMERCIAL_CRM_LOAD_BASE_BP}
                                element={<LoadBaseBrightpattern />}
                            />
                        </Route>
                        <Route
                            path={COMMERCIAL_CRM}
                            element={
                                <PrivateRoute blockPageName={commercialCrm} />
                            }
                        >
                            <Route
                                path={COMMERCIAL_CRM_LOAD_BASE_GUPSHUP}
                                element={<LoadBaseGupshup />}
                            />
                        </Route>
                        <Route
                            path={COMMERCIAL_CRM}
                            element={
                                <PrivateRoute blockPageName={commercialCrm} />
                            }
                        >
                        <Route
                            path={COMMERCIAL_CRM_LOAD_BASE_GUPSHUP_CUSTOM}
                            element={<LoadBaseGupshupCustom />}
                        />
                    </Route>
                    </>
                )}
                {(type === 'admin' ||
                    type === 'export' ||
                    validatePermission(
                        ['Staff - Calidad y Experiencia'],
                        channelList,
                        type,
                        channel
                    )) && (
                    <Route
                        path={ACTIVITYTIMES}
                        element={
                            <PrivateRoute blockPageName={exportActivityTimes} />
                        }
                    >
                        <Route
                            path={ACTIVITYTIMESEXPORT}
                            element={<ExportActivityTimes />}
                        />
                    </Route>
                )}
                {(type === 'admin' || type === 'user management') && (
                    <>
                        <Route
                            path={USERS}
                            element={<PrivateRoute blockPageName={users} />}
                        >
                            <Route path={USERLIST} element={<UserList />} />
                            <Route path={USERNEW} element={<UserNew />} />
                            <Route
                                path={`${USEREDIT}/:idUser`}
                                element={<EditUser />}
                            />
                        </Route>
                    </>
                )}
                {type === 'admin' && (
                    <>
                        <Route
                            path={SURVEYS}
                            element={<PrivateRoute blockPageName={surveys} />}
                        >
                            <Route path={SURVEYLIST} element={<SurveyList />} />
                            <Route path={SURVEYNEW} element={<SurveyNew />} />
                            <Route
                                path={`${SURVEYEDIT}/:idSurvey`}
                                element={<SurveyEdit />}
                            />
                        </Route>
                        <Route path={BLOCKPAGES} element={<PrivateRoute />}>
                            <Route index element={<ListBlockPages />} />
                        </Route>
                    </>
                )}
                <Route path={SIGNIN} element={<PublicRoute />}>
                    <Route index element={<SignIn />} />
                    <Route path={SIGNUP} element={<SignUp />} />
                    <Route
                        path={EXPIRATIONTOKEN}
                        element={<ExpirationToken />}
                    />
                </Route>
                <Route
                    element={
                        <PublicRoute blockPageName={chat} viewIcetex={true} />
                    }
                >
                    <Route path={CHAT} element={<Chat />} />
                </Route>
                <Route
                    element={
                        <PublicRoute
                            blockPageName={videoCall}
                            viewIcetex={true}
                        />
                    }
                >
                    <Route path={VIDEOCALL} element={<VideoCall />} />
                </Route>
                <Route
                    element={
                        <PublicRoute
                            blockPageName={weCallYou}
                            viewIcetex={true}
                        />
                    }
                >
                    <Route path={WECALLYOU} element={<WeCallYouClient />} />
                </Route>
                <Route
                    element={
                        <PublicRoute
                            blockPageName={videoAtencion}
                            viewIcetex={true}
                        />
                    }
                >
                    <Route path={VIDEOATENTION} element={<VideoAtention />} />
                </Route>
                <Route
                    path={`${SURVEYQUESTIONS}/:idSurvey`}
                    element={<SurveysFormView />}
                />
                <Route path={PAGENOTFOUND} element={<PageNotFound />} />
                {(type === 'admin' || type === 'voice admin') && (
                    <>
                        <Route
                            path={VOICE_BLASTER}
                            element={
                                <PrivateRoute blockPageName={voiceBlaster} />
                            }
                        >
                            <Route
                                path={VOICE_BLASTER}
                                element={<VoiceBlasterForm />}
                            />
                        </Route>
                        <Route
                            path={IVR}
                            element={<PrivateRoute blockPageName={ivr} />}
                        >
                            <Route path={IVR} element={<IvrForm />} />
                        </Route>
                    </>
                )}
            </Routes>
        </Router>
    );
};

export default AppRoutes;
